// pages/SubjectsPage.tsx — MBA Subjects list
import { useEffect } from 'react';
import { useCourseStore } from '../store/courseStore';
import BackButton from '../components/ui/BackButton';
import SubjectCard from '../components/ui/SubjectCard';

export default function SubjectsPage() {
  const courses = useCourseStore((s) => s.courses);
  const fetchCourses = useCourseStore((s) => s.fetchCourses);
  const isLoading = useCourseStore((s) => s.isLoading);

  useEffect(() => {
    if (courses.length === 0) fetchCourses();
  }, [courses.length, fetchCourses]);

  // Flatten: Course → Topic → Subject
  // We show subjects directly (skipping the Topics intermediary)
  const subjectsWithTopic: { subject: import('../types/course').Subject; topicId: string }[] = [];
  for (const course of courses) {
    for (const topic of course.topics || []) {
      for (const subject of topic.subjects || []) {
        subjectsWithTopic.push({ subject, topicId: topic.id });
      }
    }
  }

  return (
    <div className="min-h-screen bg-surface-50 safe-top safe-bottom page-enter">
      {/* Header */}
      <div className="sticky top-0 z-20 bg-surface-50/80 backdrop-blur-lg px-4 pt-3 pb-2">
        <BackButton label="Home" to="/" />
      </div>

      <div className="px-5 pb-8 max-w-lg mx-auto">
        <h1 className="text-2xl font-extrabold text-surface-900 mb-1 animate-fade-up">
          MBA Subjects
        </h1>
        <p className="text-sm text-surface-300 mb-5 animate-fade-up">
          Pick a subject to start learning
        </p>

        {isLoading && subjectsWithTopic.length === 0 ? (
          <div className="flex items-center justify-center py-20">
            <div className="w-8 h-8 border-3 border-mint-400 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : subjectsWithTopic.length === 0 ? (
          <div className="text-center py-20 text-surface-300">
            <span className="text-4xl mb-3 block">📚</span>
            <p className="font-medium">No subjects available yet</p>
          </div>
        ) : (
          <div className="space-y-3">
            {subjectsWithTopic.map(({ subject, topicId }, i) => (
              <SubjectCard
                key={subject.id}
                subject={subject}
                topicId={topicId}
                index={i}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
